"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var c = function () {
    var _ref;

    return _ref = {
        entityType: {
            "CLIENT": 1,
            "PROVIDER": 2
        },
        deviceType: {
            "DESKTOP": 1,
            "MOBILE": 2,
            "BOT": 3,
            "MOBILEAPP": 4
        },
        notificationOutcome: {
            QUEUED: 0,
            PROCESSING: 2,
            COMPLETED: 3,
            ABANDONED: 4,
            UNKNOWN: 5,
            NOTARGETFOUND: 6,
            CANCELLED: 7
        },
        profileItems: {
            BASIC_INFO: 1,
            CLIENT_PHOTO: 2,
            TRUST_VERIFICATION: 4,
            CLIENT_ABOUT_ME: 8,
            // MY_CHILDREN: 16,
            MY_HOME: 32,
            // MY_BABYSITTING_EXPERIENCE: 64,
            PROVIDER_ABOUT_ME: 128,
            PROVIDER_PHOTO: 256,
            PROVIDER_JOB_CATEGORIES: 512,
            PROVIDER_PROFILE_VISIBILITY: 1024,
            PROVIDER_CERTIFICATES: 2048,
            PROVIDER_GUARDIAN: 4096,
            CITIZENSHIP: 8192
        },
        globalUsersFilterTypes: {
            ALL_USERS: 1,
            PAYG_USERS: 2,
            ALL_PAYING_USERS: 3,
            NSW_CUSTOMERS: 4,
            VIC_CUSTOMERS: 5
        },
        globalBusinessesFilterTypes: {
            ALL_BUSINESSS: 1,
            NSW_BUSINESSES: 2,
            VIC_BUSINESSES: 3
        },
        globalProfilesFilterTypes: {
            ALL_PROFILES: 1
        },
        globalJobsFilterTypes: {
            ALL_JOBS: 1,
            JOBS_POSTED_TODAY: 2,
            JOBS_EXPIRE_TODAY: 3,
            RECURRING_JOB_POSTED_15_DAYS_AGO: 4
        },
        globalJobRequestsFilterTypes: {
            ALL_JOB_REQUESTS: 1
        },
        globalAffiliatesFilterTypes: {
            ALL_AFFILIATES: 1,
            EMPLOYEE_BENEFITS: 2,
            REFERRALS: 3
        },
        globalVouchesFilterTypes: {
            ALL_VOUCHES: 1
        },
        globalBotManagerFilterTypes: {
            ALL_BOT_FLOWS: 1
        },
        globalBotSessionsFilterTypes: {
            ALL_BOT_SESSIONS: 1
        },
        globalCertificatesFilterTypes: {
            ALL_CERTIFICATES: 1,
            PENDING_VERIFICATION: 2
        },
        globalChecksFilterTypes: {
            ALL_CHECKS: 1
        },
        events: {
            GLOBAL_FILTER_APPLIED: "GLOBAL_FILTER_APPLIED",
            AUTHORIZATION_SUCCESS: "AUTHORIZATION_SUCCESS",
            VERIFICATION_CODE_RECEIEVED: "VERIFICATION_CODE_RECEIEVED"
        },
        membershipType: {
            free: 0,
            subscription: 1,
            payg: 2,
            corporateAgreement: 3
        },
        userPaymentType: {
            NONE: 0,
            MONTHLY_STANDARD_SUBSCRIPTION: 1,
            ANNUAL_FOUNDING_MEMBER: 2,
            ANNUAL_STANDARD_SUBSCRIPTION: 3,
            QUARTERLY_STANDARD_SUBSCRIPTION: 4,
            ONE_OFF_PAYG: 5,
            SINGLE_ONE_OFF_JOB: 1001,
            SINGLE_RECURRING_JOB: 1002,
            ANNUAL_UNLIMITED_PAY_AS_YOU_GO: 1003,
            SIX_MONTHS_UNLIMITED_PAY_AS_YOU_GO: 1004,
            EXTEND_RECURRING_JOB: 1005,
            QUARTERLY_STANDARD_SUBSCRIPTION_60: 11,
            ANNUAL_STANDARD_SUBSCRIPTION_120: 12,
            ANNUAL_STANDARD_SUBSCRIPTION_180: 13,
            QUARTERLY_STANDARD_SUBSCRIPTION_75: 14,
            QUARTERLY_STANDARD_SUBSCRIPTION_90: 2015,
            ANNUAL_STANDARD_SUBSCRIPTION_150: 15,
            SINGLE_AU_PAIR_JOB: 1006,
            SINGLE_PRIMARY_SCHOOL_TUTORING_JOB: 1008,
            SINGLE_HIGH_SCHOOL_TUTORING_JOB: 1009,
            ANNUAL_BABYSITTING_SUBSCRIPTION60: 2001,
            ANNUAL_BABYSITTING_SUBSCRIPTION120: 2013,
            MONTHLY_BABYSITTING_SUBSCRIPTION40: 2014,
            ANNUAL_CHILDCARE_SUBSCRIPTION120: 2002,
            ANNUAL_TUTORING_SUBSCRIPTION90: 2003,
            ANNUAL_AU_PAIR_SUBSCRIPTION195: 2004,
            ANNUAL_PRIMARY_SCHOOL_TUTORING_SUBSCRIPTION120: 2005,
            ANNUAL_TUTORING_SUBSCRIPTION195: 2006,
            ANNUAL_HIGH_SCHOOL_TUTORING_SUBSCRIPTION195: 2007,
            ANNUAL_TUTORING_SUBSCRIPTION245: 2008,
            ANNUAL_HELPER_SUBSCRIPTION24: 3001,
            MONTHLY_HELPER_STANDARD_SUBSCRIPTION5: 3002,
            ANNUAL_HELPER_SUBSCRIPTION30: 3003,
            QUARTERLY_HELPER_SUBSCRIPTION15: 3004,
            ANNUAL_TUTORING_SUBSCRIPTION180: 2009,
            ANNUAL_FAMILY_CARE_SUBSCRIPTION240: 2010,
            ANNUAL_STANDARD_SUBSCRIPTION360: 2011,
            ANNUAL_CHILDCARE_SUBSCRIPTION180: 2012,
            QUARTERLY_BUSINESS_TIER1_SUBSCRIPTION_500: 4001,
            QUARTERLY_BUSINESS_TIER2_SUBSCRIPTION_500: 4002,
            ANNUAL_BUSINESS_TIER1_SUBSCRIPTION_1500: 4003,
            ANNUAL_BUSINESS_TIER2_SUBSCRIPTION_1500: 4004,
            ANNUAL_HELPER_SUBSCRIPTION40: 3005,
            QUARTERLY_HELPER_SUBSCRIPTION20: 3006,
            QUARTERLY_BUSINESS_TIER2_SUBSCRIPTION_750: 4005,
            MONTHLY_CHILDCARE_SUBSCRIPTION90: 2016,
            ANNUAL_COMPLETE_FAMILY_CARE_SUBSCRIPTION120: 16,
            THREE_MONTHS_HELPER_STANDARD_SUBSCRIPTION25: 3007,
            ANNUAL_HELPER_STANDARD_SUBSCRIPTION50: 3008,
            MONTHLY_CHILDCARE_SUBSCRIPTION60: 2018
        },
        walletTransactionReason: {
            ACCOUNT_CREATED: 1,
            JOB_POSTED: 2,
            JOB_CANCELLED: 3,
            ADMIN_ACTION: 4,
            SINGLE_ONE_OFF_JOB_PURCHASE: 5,
            SINGLE_RECURRING_JOB_PURCHASE: 6,
            WALLET_PAYMENT: 7,
            JOB_CANCELLED_BY_HELPER: 8,
            SPECIAL_OFFER: 11
        },
        walletTransactionType: {
            ADD: 1,
            DEDUCT: 2,
            REFUND: 3
        },
        walletTransactionOwner: {
            UNSPECIFIED: 0,
            USER: 1,
            SYSTEM: 20,
            ADMIN: 30
        },
        walletTransactionPaymentType: {
            UNSPECIFIED: 0,
            FREE: 1,
            PAID: 2
        },
        gender: {
            UNSPECIFIED: 0,
            MALE: 1,
            FEMALE: 2
        },
        accountStatus: {
            PENDING: 1,
            APPROVED: 2,
            PENDING_APPROVAL: 4
        },
        vouchStatus: {
            PENDING: 1,
            APPROVED: 2,
            CANCELLED: 3,
            EXPIRED: 4,
            NONE: 0
        },
        externalAccountType: {
            FACEBOOK: 1,
            LINKEDIN: 2
        },
        guardianRelation: {
            FATHER: 1,
            MOTHER: 2,
            LEGALGUARDIAN: 3
        },
        guardianStatus: {
            PENDING: 1,
            APPROVED: 2,
            CANCELLED: 3,
            NONE: 4
        },
        certificateCategory: {
            CHECK: 1,
            QUALIFICATION: 2,
            FIRSTAID: 3
        },
        certificateStatus: {
            PENDINGVERIFICATION: 1,
            ACTIVE: 2,
            INVALID: 3,
            EXPIRED: 4
        },
        affiliateType: {
            CREDIT: 1,
            SUBSCRIPTION: 2
        },
        jugglerType: {
            PARENT: 1,
            HELPER: 2
        },
        visaCheckStatus: {
            PENDINGVERIFICATION: 1,
            APPROVED: 2,
            INVALID: 3,
            EXPIRED: 4
        },
        locationStatus: {
            UNSPECIFIED: 0,
            NEWLEAD: 1,
            PURCHASEDLEAD: 2,
            CONTACTEDLEAD: 3,
            FOLLOWEDUP: 4,
            ARCHIVED: 5,
            INPROGRESS: 6
        },
        locationType: {
            UNSPECIFIED: 0,
            SCHOOL: 1,
            CENTRE_BASED_DAYCARE: 2,
            FAMILY_DAYCARE: 3,
            INHOME_CARE: 4,
            OUTSIDE_SCHOOL_HOURS_CARE: 5
        },
        getLocationTypeText: function getLocationTypeText(type) {
            switch (type) {
                case c.locationType.UNSPECIFIED:
                    return "Unspecified";
                case c.locationType.SCHOOL:
                    return "School";
                case c.locationType.CENTRE_BASED_DAYCARE:
                    return "Centre Day Care";
                case c.locationType.FAMILY_DAYCARE:
                    return "Family Day Care";
                case c.locationType.INHOME_CARE:
                    return "In-Home Care";
                case c.locationType.OUTSIDE_SCHOOL_HOURS_CARE:
                    return "OOSH";
            }
        }
    }, (0, _defineProperty3.default)(_ref, "locationStatus", {
        UNSPECIFIED: 0,
        NEW_LEAD: 1,
        EDM_SENT: 2,
        CALLS_COMMENCED: 3,
        CONTACT_MADE: 4,
        NOT_INTERESTED: 5,
        INTERESTED_IN_PROGRESS: 6,
        ACQUIRED: 7,
        EDM_READY: 8,
        EDM_OPENED: 9,
        EDM_CLICKED: 10,
        EDM_REJECTED: 11
    }), (0, _defineProperty3.default)(_ref, "getLocationStatusText", function getLocationStatusText(locationStatus) {
        switch (locationStatus) {
            case c.locationStatus.UNSPECIFIED:
                return 'Unspecified';
            case c.locationStatus.NEW_LEAD:
                return 'New Lead';
            case c.locationStatus.EDM_SENT:
                return 'EDM Sent';
            case c.locationStatus.EDM_READY:
                return 'EDM Ready';
            case c.locationStatus.EDM_OPENED:
                return 'EDM Opened';
            case c.locationStatus.EDM_CLICKED:
                return 'EDM Clicked';
            case c.locationStatus.EDM_REJECTED:
                return 'EDM Rejected';
            case c.locationStatus.CALLS_COMMENCED:
                return 'Calls Commenced';
            case c.locationStatus.CONTACT_MADE:
                return 'Contact Made';
            case c.locationStatus.NOT_INTERESTED:
                return 'Not Interested';
            case c.locationStatus.INTERESTED_IN_PROGRESS:
                return 'Interested - In-Progress';
            case c.locationStatus.ACQUIRED:
                return 'Acquired';
            default:
                return 'Unknown';
        }
    }), (0, _defineProperty3.default)(_ref, "vouchReferenceType", {
        FAMILY: 1,
        CHILDCAREEMPLOYMENT: 2,
        NONCHILDCAREEMPLOYMENT: 3,
        OTHER: 4,
        JUGGLESTREET: 5,
        UNSPECIFIED: 0,
        REFERENCES: 6
    }), (0, _defineProperty3.default)(_ref, "certificateType", {
        WWCC: 1
    }), (0, _defineProperty3.default)(_ref, "mediaReviewStatuts", {
        UNSPECIFIED: 0,
        PENDING: 1,
        APPROVED: 2,
        REJECTED: 3
    }), (0, _defineProperty3.default)(_ref, "surveyResponse", {
        YES: 1,
        NO: 2,
        NA: 3
    }), (0, _defineProperty3.default)(_ref, "profileReviewStatus", {
        APPROVED: 0,
        REQUIRED: 1,
        IN_PROGRESS: 2
    }), (0, _defineProperty3.default)(_ref, "jobType", {
        BABYSITTING: 1,
        NANNYING: 2,
        BEFORE_SCHOOL_CARE: 4,
        AFTER_SCHOOL_CARE: 8,
        BEFORE_AFTER_SCHOOL_CARE: 12,
        RECURRING_JOB: 14,
        AU_PAIR: 16,
        PRIMARY_SCHOOL_TUTORING: 64,
        HIGH_SCHOOL_TUTORING: 128,
        ONE_OFF_ODD_JOBS: 256,
        JUNIOR_HIGH_SCHOOL_TUTORING: 512,
        SENIOR_HIGH_SCHOOL_TUTORING: 1024
    }), (0, _defineProperty3.default)(_ref, "botFlowStatus", {
        INACTIVE: 0,
        TEST: 1,
        LIVE: 2
    }), (0, _defineProperty3.default)(_ref, "jobStatus", {
        PENDING: 1,
        AWARDED: 2,
        CANCELLED: 3,
        COMPLETED: 4,
        FILLED: 5,
        FILLED_AND_CANCELLED: 6
    }), (0, _defineProperty3.default)(_ref, "jobRequestStatus", {
        NEW_REQUEST: 1,
        CALL_SCHEDULED: 2,
        JOB_POSTED: 3,
        JOB_TRANSFERRED: 4,
        JOB_AWARDED: 5
    }), (0, _defineProperty3.default)(_ref, "managedBy", {
        USER: 1,
        SYSTEM: 20
    }), (0, _defineProperty3.default)(_ref, "screens", {
        ANALYTICS: "analytics",
        USERS: "users",
        JOBS: "jobs",
        JOB_REQUESTS: "jobRequests",
        CERTIFICATES: "certificates",
        CHECKS: "checks",
        AFFILIATES: "affiliates",
        MEDIA: "media",
        SURVEY: "survey",
        BOT_MANAGER: "botManager",
        BOT_FLOW: "botFlow",
        BOT_SESSIONS: "botSessions",
        VOUCHES: "vouches",
        BUSINESSES: "businesses"
    }), (0, _defineProperty3.default)(_ref, "flowDiagrams", {
        SMS_CHANNEL: 1,
        FACEBOOK_CHANNEL: 2,
        LOCATE_HELPERS_IN_AREA_FLOW: 3,
        POST_JOB_FLOW: 4,
        DISPLAY_PROFILE_FLOW: 5,
        BABYSITTING_JOB: 6,
        RECURRING_JOB: 7
    }), (0, _defineProperty3.default)(_ref, "adminEntitiesActionType", {
        UPDATE_ACCOUNT_INFO: 1,
        CREDIT_ACCOUNT_BALANCE: 2,
        REFRESH_CACHE: 3
    }), _ref;
}();

exports.default = c;


/** WEBPACK FOOTER **
 ** ./client/app/utils/constants.js
 **/